export const LOGIN_OR_REGISTRATION_MODAL_OPEN_CONSTANT = 'LOGIN_OR_REGISTRATION_MODAL_OPEN';
